import { connect } from "react-redux";

import PrivateRouteComponent from "./PrivateRoute";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(PrivateRouteComponent);
